// import React, { useState, useEffect } from 'react';
// import Header from './components/Header';
// import Image from './components/image';
// import Partners from './components/partners';
// import AboutUs from './components/aboutus';
// import ContactUs from './components/contactus';
// import Loader from './components/Loader';
// import Modal from './components/Modal';

// function App() {
//   const [isLoading, setIsLoading] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [bookingType, setBookingType] = useState('');

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 5500);

//     return () => clearTimeout(timer);
//   }, []);

//   const openModal = (type) => {
//     setBookingType(type);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div>
//       {isLoading ? (
//         <Loader />
//       ) : (
//         <>
//           <Header  />
//           <Image openModal={openModal} />
//           <Partners />
//           <AboutUs />
//           <ContactUs />
//         </>
//       )}
//       {isModalOpen && <Modal onClose={closeModal} bookingType={bookingType} />}
//     </div>
//   );
// }

// export default App;




// import React, { useState, useEffect } from "react";
// import { Routes, Route } from "react-router-dom";

// import Header from "./components/Header";
// import HeroSection from "./components/image";
// import Partners from "./components/partners";
// import AboutUs from "./components/aboutus";
// import ContactUs from "./components/contactus";
// import Loader from "./components/Loader";
// import Modal from "./components/Modal";

// function App() {
//   const [isLoading, setIsLoading] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [bookingType, setBookingType] = useState("");

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, []);

//   const openModal = (type) => {
//     setBookingType(type);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setBookingType("");
//   };

//   if (isLoading) return <Loader />;

//   return (
//     <>
//       <Header />

//       <Routes>
//         <Route path="/" element={<HeroSection openModal={openModal} />} />
//         <Route path="/partners" element={<Partners />} />
//         <Route path="/about" element={<AboutUs />} />
//         <Route path="/contact" element={<ContactUs />} />
//       </Routes>

//       {isModalOpen && (
//         <Modal onClose={closeModal} bookingType={bookingType} />
//       )}
//     </>
//   );
// }

// export default App;



import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import HeroSection from "./components/image";
import Partners from "./components/partners";
import AboutUs from "./components/aboutus";
import ContactUs from "./components/contactus";
import Loader from "./components/Loader";
import Modal from "./components/Modal";
import Auth from "./components/Auth";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bookingType, setBookingType] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const openModal = (type) => {
    setBookingType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setBookingType("");
  };

  // 1️⃣ LOADER
  if (isLoading) return <Loader />;

  // 2️⃣ AUTH SCREEN
  if (!isAuthenticated)
    return <Auth onAuthSuccess={() => setIsAuthenticated(true)} />;

  // 3️⃣ MAIN APP
  return (
    <>
      <Header />

      <Routes>
        <Route path="/" element={<HeroSection openModal={openModal} />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>

      {isModalOpen && (
        <Modal onClose={closeModal} bookingType={bookingType} />
      )}
    </>
  );
}

export default App;
